// ประกาศประเภทของวิธีชำระเงินที่รองรับ
export type PaymentMethod = 
  | 'card' 
  | 'cardInstallments' 
  | 'eWallets' 
  | 'mobileBanking' 
  | 'qrPromptPay' 
  | 'buyNowPayLater';

// Action type constants
export const SET_PAYMENT_METHOD_ENABLED = 'SET_PAYMENT_METHOD_ENABLED';
export const SET_AMOUNT = 'SET_AMOUNT';
export const SET_CURRENCY = 'SET_CURRENCY';
export const SET_REFERENCE_ID = 'SET_REFERENCE_ID';
export const SET_DESCRIPTION = 'SET_DESCRIPTION';
export const CREATE_PAYMENT_LINK_REQUEST = 'CREATE_PAYMENT_LINK_REQUEST';
export const CREATE_PAYMENT_LINK_SUCCESS = 'CREATE_PAYMENT_LINK_SUCCESS';
export const CREATE_PAYMENT_LINK_FAILURE = 'CREATE_PAYMENT_LINK_FAILURE';
export const PAYMENT_RESET = 'PAYMENT_RESET';

// กำหนดรูปแบบ Payload ของแต่ละ Action
interface SetPaymentMethodPayload {
  method: PaymentMethod;
  enabled: boolean;
}
interface CreatePaymentLinkSuccessPayload {
  id: string;
  url: string;
}
interface CreatePaymentLinkFailurePayload {
  error: string;
}

// กำหนดรูปแบบ Action Objects ด้วย TypeScript interfaces
export interface SetPaymentMethodAction {
  type: typeof SET_PAYMENT_METHOD_ENABLED;
  payload: SetPaymentMethodPayload;
}
export interface SetAmountAction {
  type: typeof SET_AMOUNT
  payload: number
}
export interface SetCurrencyAction {
  type: typeof SET_CURRENCY;
  payload: string;
}
export interface SetReferenceIdAction {
  type: typeof SET_REFERENCE_ID;
  payload: string;
}
export interface SetDescriptionAction {
  type: typeof SET_DESCRIPTION;
  payload: string;
}
export interface CreatePaymentLinkRequestAction {
  type: typeof CREATE_PAYMENT_LINK_REQUEST;
  // อาจเพิ่ม payload ได้หากต้องการข้อมูลเพิ่มเติมเมื่อเรียก (ที่นี่ไม่ใช้ payload เพราะจะใช้ข้อมูลจาก state โดย saga)
}
export interface CreatePaymentLinkSuccessAction {
  type: typeof CREATE_PAYMENT_LINK_SUCCESS;
  payload: CreatePaymentLinkSuccessPayload;
}
export interface CreatePaymentLinkFailureAction {
  type: typeof CREATE_PAYMENT_LINK_FAILURE;
  payload: CreatePaymentLinkFailurePayload;
}
export interface PaymentResetAction {
  type: typeof PAYMENT_RESET;
}

// รวมชนิดของ Actions ที่เป็นไปได้ (Union Type)
export type PaymentLinkAction =
  | SetPaymentMethodAction
  | SetAmountAction
  | SetCurrencyAction
  | SetReferenceIdAction
  | SetDescriptionAction
  | CreatePaymentLinkRequestAction
  | CreatePaymentLinkSuccessAction
  | CreatePaymentLinkFailureAction
  | PaymentResetAction

